<template lang="pug">
    .icebreakerMobile
        .ship
            .detail_icon(v-for="(detail, ind) in details" :class="['n'+detail.name, ind===activeSlide&&'active']" )
        transition
            .details(v-if="openSliderAndGallery")
                .swiper-container
                    .swiper-wrapper
                        .swiper-slide(v-for="slide in details")
                            .img(:style="{backgroundImage: 'url('+slide.img+')'}")
                            .text(v-html="slide.p")
                IcebreakerGallery(:slides="slides")

        .back(v-if="openSliderAndGallery" @click="$emit('closeSliderAndGallery')")
</template>

<script>
    import IcebreakerGallery from '@/components/concurs/IcebreakerGallery'
    export default {
        name: "icebreakerMobile",
        props:['details', 'slides', 'openSliderAndGallery'],
        data:()=>({
            slider: null,
            activeSlide: 0,
        }),
        watch:{
            openSliderAndGallery(openSliderAndGallery){
                if (openSliderAndGallery){
                    setTimeout(this.initSlider)
                }
            }
        },
        methods:{
            initSlider() {
                const self = this;
                this.slider = new Swiper('.icebreakerMobile .swiper-container', {
                    speed: 500,
                    loop: true,
                    spaceBetween: 10,
                    slidesPerView: 1.22,
                    centeredSlides: true,
                    autoHeight: true,
                    on:{
                        slideChange(){
                            self.activeSlide = this.realIndex;
                        }
                    }
                });
            },
        },
        components:{
            IcebreakerGallery
        },
    }
</script>

<style scoped lang="scss">
    @import "@/assets/scss/_functions.scss";
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/_mixins.scss";
    .icebreakerMobile{
        position: relative;
    }
    .ship{
        position: relative;
        background: url(../../assets/img/concurs/icebreaker-mobile.png) no-repeat center top / contain;
        height: 65vw;
        .detail_icon{
            position: absolute;
            width: 4.5vw;
            height: 4.5vw;
            background: url(../../assets/img/concurs/icebreakerDetail_icon.png) no-repeat center center / 65% auto $blue;
            transition: .2s;
            &.active{
                background-color: $red;
            }
            &.n87 {
                left: 12%;
                bottom: 12%;
            }
            &.n88 {
                left: 28%;
                bottom: 25%;
            }
            &.n89 {
                left: 52%;
                bottom: 32%;
            }
            &.n90 {
                left: 74%;
                bottom: 42%;
            }
            &.n91 {
                left: 44%;
                top: 29%;
            }
            &.n92 {
                left: 67%;
                top: 39%;
            }
            &.n93 {
                left: 83%;
                bottom: 54%;
            }
            &.n94 {
                left: 52.7%;
                top: 10%;
            }
            &.n95 {
                left: 75%;
                bottom: 65%;
            }
        }
    }
    .details{
        padding-top: 0.8vw;
        .swiper-container{
            position: relative;
            &:before {
                content: '';
                display: block;
                position: absolute;
                top: 7vw;
                left: 0;
                right: 0;
                bottom: 0;
                background-image: linear-gradient(27deg, rgb(0, 34, 119) 0%, rgb(30, 130, 245) 100%);
                transform: skewY(-21.5deg);
                transform-origin: 100% 0;
            }
        }
        .swiper-slide{
            .img{
                height: 47.5vw;
                background: no-repeat center center / cover;
            }
            .text{
                width: 110%;
                margin-left: -5%;
                padding: 6vw 0 11vw;

                font-family: 'Fira Sans Extra Condensed', sans-serif;
                font-size: 4vw;
                line-height: 1.35;
                text-align: center;
                color: #fff;
                opacity: 0;
                transition: .2s;
            }
            &.swiper-slide-active{
                .text{
                    opacity: 1;
                }
            }
        }
    }
    .back{
        position: absolute;
        top: 108vw;
        left: 0;
        z-index: 1;
        width: 7vw;
        height: 18vw;
        background: url(../../assets/img/button_back.png) no-repeat left top/contain;
    }
    .v-enter{
        opacity: 0;
        transform: translateY(10vw);
    }
    .v-enter-active{
        transition: .3s;

    }
    .v-leave-active{
        transition: .3s;
        opacity: 0;
    }
</style>
